import React, { useState, useEffect } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import Aos from "aos";
import TestSlider from "../Components/TestSlider";
import { getTestimonials } from "../Common/apis";
import Loader from "../Loader/Loader.jsx";

function WhatClient() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });

    async function fetchTestimonials() {
      try {
        const res = await getTestimonials();
        setTestimonials(res?.data || []);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchTestimonials();
  }, []);

  if (loading) return <Loader />;
  return (
    <>
      <div className="new-home overflow-hidden">
        <Navbar2 />
        <div className="w-full relative">
          <div className="lg:mt-[54px] absolute xl:right-[-70px] right-[0px] top-[-158px] mt-[50px] lg:w-auto w-full">
            <div className="lg:flex hidden flex-col pb-[24px] gap-[12px] mr-[-70px] items-end">
              <img
                data-aos="flip-up"
                src="/assets/media/item6.svg"
                className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/media/item5.svg"
                className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                alt=""
              />
            </div>
            <div className="flex lg:hidden absolute top-[-40px] lg:right-[0px] md:right-[-65px] right-[-65px] flex-col lg:pb-[45px] pb-[16px] gap-[8px] items-end">
              <img
                data-aos="flip-up"
                src="/assets/media/mobile-item6.svg"
                className="h-[53px]"
                alt=""
              />
              <img
                data-aos="flip-up"
                src="/assets/media/mobile-item5.svg"
                className="h-[53px]"
                alt=""
              />
            </div>
          </div>
          <div className="test-slider mt-[200px] px-[20px]">
            <h6 className="left-title">Testimonials</h6>
            <div className="md:pt-0 pt-[35px]">
              <TestSlider data={testimonials}/>
            </div>
          </div>
        </div>
        <Footer2 />
      </div>
    </>
  );
}

export default WhatClient;
